import ChevronRightIcon from "assets/icon/ChevronRightIcon";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Setting(){
    let navigate = useNavigate()
    
    const [isAdmin, setIsAdmin] = useState(localStorage.getItem('IsAdmin'))

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">Settings</span>
            </div>
            <hr />
            <div className="bg-white p-4 rounded-xl shadow-sm">
                { isAdmin === "1" && (
                    <div>
                        <div className="">
                            <span className="font-semibold text-lg">User Setting</span>
                        </div>
                        <hr />
                        <button className="px-4 py-4  w-full text-left flex justify-between hover:bg-slate-100 transition-all" onClick={() => {navigate("/user")}}>
                            <span className="">User</span>
                            <ChevronRightIcon className="fill-black w-6" />
                        </button>
                        <hr />
                    </div>
                )}
                
                <div className="mt-4">
                    <span className="font-semibold text-lg">Vehicle Setting</span>
                </div>
                <hr />
                <button className="px-4 py-4  w-full text-left flex justify-between hover:bg-slate-100 transition-all" onClick={() => {navigate("/setting/vehicle-brand")}}>
                    <span className="">Vehicle Brand</span>
                    <ChevronRightIcon className="fill-black w-6" />
                </button>
                <hr />
                <button className="px-4 py-4  w-full text-left flex justify-between hover:bg-slate-100 transition-all" onClick={() => {navigate("/setting/vehicle-color")}}>
                    <span className="">Vehicle Color</span>
                    <ChevronRightIcon className="fill-black w-6" />
                </button>
            </div>
        </div>
    )
}